import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const EmailListRow = ({ subject, recipient }) => {
   return (
      <div className="flex gap-6 w-[500px] p-4 border-b border-solid border-gray-800 last:border-b-0">
         <div>
            <div className="inline-block text-blue-200 bg-blue-400/20 rounded-full px-2 text-[11px] border border-solid border-blue-500/50">Sent</div>
         </div>
         <div className="text-white">
            <div className="text-xs font-semibold">{subject}</div>
            <div className="text-xs opacity-50">
               {recipient}
            </div>
         </div>
      </div>
   )
}

EmailListRow.propTypes = {
   subject: PropTypes.string.isRequired,
   recipient: PropTypes.string.isRequired
}

const EmailFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div className={classNames('absolute top-[15%] left-[15%] w-[70%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700', visible ? 'translate-x-0 opacity-90' : 'translate-x-10 opacity-0')}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/email/1.png"
               alt="Email"
            />
         </div>

         <div
            className={classNames(
               'absolute top-[20%] sm:top-[45%] left-[45%] sm:left-[55%] w-[100%] rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] bg-black/90 transition-all duration-700 delay-100 py-2 scale-[70%] sm:scale-100',
               visible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
            )}>
            <EmailListRow subject="Welcome to the Community" recipient="Angela Johnson" />
            <EmailListRow subject="Account Verification" recipient="Angela Johnson" />
            <EmailListRow subject="Password Reset Request" recipient="Angela Johnson" />
         </div>
      </div>
   )
}

EmailFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default EmailFeature
